const en_US = {
  title: 'System Version',
  frontend: 'Frontend Version',
  backend: 'Backend Version',
};
export default en_US;
